import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Administration' },
    { value: 2, label: 'Update' },
  ],
});
